import React from 'react';
import { AccordionBodyItem } from 'component/Accordion';
import Cleave from 'cleave.js/react';

export const NumberOfPeopleSurveyed = (props) => {
  const { formData, handleNumberOfPeopleSurveyed } = props;

  return (
    <AccordionBodyItem
      accordionSubId={(
        <div>
          <span>3.3</span>
        </div>
      )}
            titleUA="Кількість опитаних осіб"
      titleEN="Number of people surveyed"
      children={(
        <div className="flex-group" style={{ marginRight: '20px' }}>
          <Cleave
            placeholder="0"
            id="number_of_people_surveyed"
            name="number_of_people_surveyed"
            className="number"
            value={formData?.info?.final_indicators?.number_of_people_surveyed}
            autoComplete="off"
            options={{
              numericOnly: true,
              stripLeadingZeroes: true,
            }}
            onChange={(e) => handleNumberOfPeopleSurveyed(e.target.value.replace(/^0+/, ''))}
            disable="false"
          />
        </div>
      )}
    />
  );
};